"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HelperTooltip;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _iconsMaterial = require("@mui/icons-material");
var _material = require("@mui/material");
var _react = _interopRequireDefault(require("react"));
function HelperTooltip(_ref) {
  var children = _ref.children,
    _ref$fontSize = _ref.fontSize,
    fontSize = _ref$fontSize === void 0 ? 18 : _ref$fontSize,
    innerSx = _ref.innerSx,
    outerSx = _ref.outerSx,
    title = _ref.title,
    tooltipProps = _ref.tooltipProps;
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: (0, _extends2.default)({
      alignItems: 'baseline',
      display: 'flex',
      gap: 1,
      height: '100%'
    }, outerSx)
  }, children, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: (0, _extends2.default)({
      marginRight: 1,
      opacity: 0.38,
      position: 'relative',
      top: '3px',
      width: fontSize
    }, innerSx)
  }, title && /*#__PURE__*/_react.default.createElement(_material.Tooltip, (0, _extends2.default)({
    arrow: true,
    placement: "right",
    title: title
  }, tooltipProps), /*#__PURE__*/_react.default.createElement(_iconsMaterial.HelpOutline, {
    sx: {
      fontSize
    }
  }))));
}